import eventEmitter from '../../foreground/contentFramePortalGateInternalMethods/eventEmitter';
import { getCurrentTimeIndex, getElementFromTime } from '../../foreground/utils/youtubeHelpers';
import type { MobileContentFrameWindow } from './types';

declare let window: MobileContentFrameWindow;

const CURRENT_TELEPROMPTER_CLASSNAME = 'youtube-current-teleprompter';
const PADDING_TOP = 50;

let summarySectionHeight = 0;
let autoScrolling = false;

export const setYTAutoScrolling = (enabled: boolean) => {
  autoScrolling = enabled;
};

const summarySectionHeightAnimationDelay = 500;

const onElapsedTime = ({ elapsedSeconds }: { elapsedSeconds: number; }) => {
  const titleHeight = document.querySelector('.document-header-title')?.clientHeight ?? 0;
  const transcriptTimesEls = document.querySelectorAll<HTMLElement>('span[data-rw-start]');
  const times = Array.from(transcriptTimesEls, (el) => Number(el.dataset.rwStart));
  // Remove previous highlight
  const currentTeleprompter = document.querySelector(
    `.${CURRENT_TELEPROMPTER_CLASSNAME}`,
  ) as HTMLSpanElement | null;

  if (currentTeleprompter) {
    currentTeleprompter.classList.remove(CURRENT_TELEPROMPTER_CLASSNAME);
  }

  // Add new highlight
  const currentStartTimeIndex = getCurrentTimeIndex({ times, currentTime: elapsedSeconds });
  const currentStartTime = currentStartTimeIndex !== null && times[currentStartTimeIndex];

  if (currentStartTime) {
    const el = getElementFromTime(currentStartTime);

    if (!el) {
      return;
    }

    el.classList.add(CURRENT_TELEPROMPTER_CLASSNAME);

    if (autoScrolling) {
      document.scrollingElement?.scroll({ top: el.offsetTop - PADDING_TOP + titleHeight + summarySectionHeight, behavior: 'smooth' });
    }
  }
};

const setSummarySectionHeight = ({ shouldWaitForAnimation = true }: { shouldWaitForAnimation?: boolean; } = {}) => {
  setTimeout(() => {
    summarySectionHeight = document.querySelector('.summary-section')?.clientHeight ?? 0;
  }, shouldWaitForAnimation ? summarySectionHeightAnimationDelay : 0);
};

export const initYouTubeTeleprompter = ({
  scrollDepth,
  isAutoScrollEnabled,
}: { scrollDepth: number; isAutoScrollEnabled?: boolean; }) => {
  autoScrolling = Boolean(isAutoScrollEnabled);

  if (summarySectionHeight === 0) {
    setSummarySectionHeight({ shouldWaitForAnimation: false });
  }


  eventEmitter.on('summary-container-toggled', setSummarySectionHeight);
  window.portalGateToForeground.on('youtube-video-elapsed', onElapsedTime);
};

export const destroyYoutubeTeleprompter = () => {
  eventEmitter.off('summary-container-toggled', setSummarySectionHeight);
  window.portalGateToForeground.off('youtube-video-elapsed', onElapsedTime);
};

